import { render, staticRenderFns } from "./RoleFeature.vue?vue&type=template&id=6afda50c"
import script from "./RoleFeature.vue?vue&type=script&lang=js"
export * from "./RoleFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports